"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelValue: {
        type: String,
        default: undefined
    },
    deserialization: {
        type: Object,
        default: undefined
    },
    domain: {
        type: String,
        default: undefined
    },
    encoded: {
        type: Boolean,
        default: undefined
    },
    immutables: {
        type: [Boolean, Object],
        default: undefined
    },
    messages: {
        type: Object,
        default: undefined
    },
    pasteCleanup: {
        type: Object,
        default: undefined
    },
    pdf: {
        type: Object,
        default: undefined
    },
    resizable: {
        type: [Boolean, Object],
        default: undefined
    },
    serialization: {
        type: Object,
        default: undefined
    },
    stylesheets: {
        type: Array,
        default: undefined
    },
    tools: {
        type: Array,
        default: undefined
    },
    imageBrowser: {
        type: Object,
        default: undefined
    },
    fileBrowser: {
        type: Object,
        default: undefined
    },
    tag: {
        type: String,
        default: undefined
    },
    value: {
        type: String,
        default: undefined
    },
    placeholder: {
        type: String,
        default: undefined
    },

    // Events
    change: Function,
    execute: Function,
    keydown: Function,
    keyup: Function,
    paste: Function,
    pdfExport: Function,
    select: Function
};